import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#20516D",
      "fill-rule": "evenodd",
      d: "M21.314 16.618c.455-1.203.686-2.595.686-4.147 0-3.092-.902-5.504-2.686-7.182-1.79-1.686-4.252-2.539-7.308-2.539h-.02c-.615 0-.84.81-.315 1.131l6.344 3.88c.948.581 1.574 1.252 1.86 1.994.307.776.218 1.564-.254 2.337-.327.532-.732.918-1.21 1.146-.47.228-1.064.334-1.814.323l-9.043-.205q-1.232-.03-1.574.526c-.113.185-.376.615.639 1.237l8.136 4.99c1.44.884 3.3.71 4.537-.441l.022-.021a8.1 8.1 0 0 0 2-3.029m-8.993 4.452-6.64-4.073c-2.404-1.47-2.113-3.079-1.447-4.168.317-.517.71-.89 1.17-1.108.442-.211 1.039-.316 1.821-.315l9.086.135c.61.005.91-.064 1.057-.123a.92.92 0 0 0 .46-.408c.121-.197.404-.658-.707-1.338L9.204 4.829a3.756 3.756 0 0 0-4.525.45l-.015.014C2.894 6.957 2 9.377 2 12.475c0 3.09.895 5.504 2.664 7.168 1.805 1.7 4.266 2.553 7.323 2.553h.02c.611 0 .835-.806.314-1.126",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }